__turbopack_context__.v({
  "accordion": "TP-vcW_accordion",
  "accordionButton": "TP-vcW_accordionButton",
  "accordionWrap": "TP-vcW_accordionWrap",
  "app": "TP-vcW_app",
  "appCopy": "TP-vcW_appCopy",
  "appMobile": "TP-vcW_appMobile",
  "appTexts": "TP-vcW_appTexts",
  "bottom": "TP-vcW_bottom",
  "brand": "TP-vcW_brand",
  "colLinks": "TP-vcW_colLinks",
  "colTitle": "TP-vcW_colTitle",
  "colTitleOpen": "TP-vcW_colTitleOpen",
  "column": "TP-vcW_column",
  "columns": "TP-vcW_columns",
  "countries": "TP-vcW_countries",
  "countryLink": "TP-vcW_countryLink",
  "countryLinkSelected": "TP-vcW_countryLinkSelected",
  "countryList": "TP-vcW_countryList",
  "dot": "TP-vcW_dot",
  "inlineLink": "TP-vcW_inlineLink",
  "inner": "TP-vcW_inner",
  "inscribe": "TP-vcW_inscribe",
  "inscribeChevron": "TP-vcW_inscribeChevron",
  "inscribeLabel": "TP-vcW_inscribeLabel",
  "legal": "TP-vcW_legal",
  "legalLink": "TP-vcW_legalLink",
  "link": "TP-vcW_link",
  "logo": "TP-vcW_logo",
  "logoLink": "TP-vcW_logoLink",
  "mid": "TP-vcW_mid",
  "newsCopy": "TP-vcW_newsCopy",
  "newsTitle": "TP-vcW_newsTitle",
  "newsletterBlock": "TP-vcW_newsletterBlock",
  "paymentList": "TP-vcW_paymentList",
  "paymentLogo": "TP-vcW_paymentLogo",
  "payments": "TP-vcW_payments",
  "paymentsLabel": "TP-vcW_paymentsLabel",
  "qr": "TP-vcW_qr",
  "root": "TP-vcW_root",
  "sectionLabel": "TP-vcW_sectionLabel",
  "socialLink": "TP-vcW_socialLink",
  "socialList": "TP-vcW_socialList",
  "tagBrAfterAcompanar": "TP-vcW_tagBrAfterAcompanar",
  "tagBrAfterMomentos": "TP-vcW_tagBrAfterMomentos",
  "tagBrAfterPensados": "TP-vcW_tagBrAfterPensados",
  "tagline": "TP-vcW_tagline",
  "top": "TP-vcW_top",
});
